<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToIcon'
});
</script>
<template>
	<span ref="el" :flex="flex ? flex : null" class="to-icon" :class="setClass" @click="clickHandle" @mousedown="mousedownHandle">
		<span ref="text" class="to-icon-text">
			<slot></slot>
		</span>
	</span>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const el = ref(null)
// 定义 props
export interface Props {
	flex?: boolean
	value?: string
	type?: string
	color?: string
	mode?: string
	link?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	value: '',
	type: '',
	color: 'default',
	mode: 'default',
	link: false,
	flex: false
})

const emit = defineEmits<{
	(e: 'click', evt: MouseEvent): void
	(e: 'mousedown', evt: MouseEvent): void
}>()

// ref
const text = ref<HTMLElement | null>(null)

// 计算 class
const setClass = computed(() => {
	const arr: string[] = props.value ? [`value-${props.value}`] : []

	if (props.type === 'fill') {
		arr.push('type-fill')
	}

	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}

	if (props.color) {
		arr.push(`color-${props.color}`)
	}

	if (props.link) {
		arr.push('is-link')
	}

	return arr
})

// 事件处理
function clickHandle(evt: MouseEvent) {
	emit('click', evt)
}

function mousedownHandle(evt: MouseEvent) {
	emit('mousedown', evt)
}
defineExpose({ el })
</script>
